import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Get the API base URL - handles custom domains automatically
export function getApiUrl() {
  const currentHost = window.location.hostname;
  
  // If we're on a custom domain (not emergent, not localhost), use relative URL
  const isEmergentDomain = currentHost.includes('emergent');
  const isLocalhost = currentHost.includes('localhost') || currentHost === '127.0.0.1';
  
  if (!isEmergentDomain && !isLocalhost) {
    return '/api';
  }
  
  // For emergent domains or localhost, use env URL if available
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl) {
    return `${envUrl}/api`;
  }
  
  return '/api';
}
